import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    // Set up the modal to close when clicking anywhere
    this.element.addEventListener("click", this.closeModal.bind(this));
  }

  closeModal() {
    const modal = this.element.closest(".modal");
    const bsModal = bootstrap.Modal.getInstance(modal);
    if (bsModal) bsModal.hide();
  }
}
